module.exports = __webpack_public_path__ + "static/media/logo for Youth.0dbf51ff.svg";